import { useContext } from 'react';
import { AuthContext } from '../components/AuthContext';

export const usePermissions = () => {
    const { user } = useContext(AuthContext);

    const can = (permissionName) => {
        return user?.permission_names?.includes(permissionName) ?? false;
    };

    return { user, can };
};

/**
 * A component that renders its children only if the user has the required permission(s).
 * @param {{
 * permission: string,  // Check for a single permission
 * any: string[],       // Check for ANY permission in an array
 * children: React.ReactNode
 * }} props
 */
export const Can = ({ permission, any, children }) => {
    const { user } = useContext(AuthContext);

    const check = () => {
        const userPermissions = user?.permission_names || [];

        // If the 'any' prop is provided, check if the user has at least one of the permissions
        if (any && Array.isArray(any)) {
            return any.some(p => userPermissions.includes(p));
        }

        // Otherwise, fall back to checking for a single permission
        if (permission) {
            return userPermissions.includes(permission);
        }

        return false;
    };

    if (check()) {
        return <>{children}</>;
    }

    return null;
};